import React from 'react';
import useInView from '../../hooks/useInView';
import styles from './ImportServices.module.css';

const services = [
  {
    icon: '📋',
    title: 'Таможенное оформление и сертификация',
    text: 'Берем на себя подготовку полного пакета документов, необходимых для прохождения таможенных процедур и получения обязательных сертификатов и деклараций.'
  },
  {
    icon: '🚚',
    title: 'Организация доставки',
    text: 'Обеспечим безопасную и быструю транспортировку ваших товаров от поставщика до вашего склада, оптимизируя маршруты и сроки.'
  },
  {
    icon: '⚖️',
    title: 'Юридическое сопровождение сделок',
    text: 'Оформим все необходимые документы и обеспечим юридическую чистоту сделки, полностью учитывая ваши требования и защищая ваши интересы.'
  },
  {
    icon: '💰',
    title: 'Финансовое сопровождение',
    text: 'Контроль валютных операций, подготовка финансовых документов, сопровождение расчётов с иностранными контрагентами и валютный контроль.'
  }
];

export default function ImportServices() {
  const [ref, isVisible] = useInView();

  return (
    <section className={styles.section} id="services" ref={ref}>
      <div className={styles.container}>
        <div style={{ textAlign: 'center' }}>
          <span className={styles.badge}>Импорт</span>
        </div>
        <h2 className={styles.title}>Импорт товаров в Россию</h2>
        <p className={styles.subtitle}>
          Комплексное сопровождение импортных операций из Европы, Турции, Китая, Индии и Вьетнама
        </p>

        <div className={styles.grid}>
          {services.map((s, i) => (
            <div
              className={`${styles.card} ${isVisible ? styles.cardVisible : ''}`}
              key={i}
              style={{ transitionDelay: `${i * 0.1}s` }}
            >
              <div className={styles.iconWrap}>{s.icon}</div>
              <h3 className={styles.cardTitle}>{s.title}</h3>
              <p className={styles.cardText}>{s.text}</p>
            </div>
          ))}
        </div>

        <div className={`${styles.description} ${isVisible ? styles.descVisible : ''}`}>
          <h3 className={styles.descTitle}>Комплексный подход к импорту</h3>
          <p className={styles.descText}>
            Ведение импортной деятельности в Российскую Федерацию требует не только опыта,
            но и надежного партнера, который возьмет на себя сложности, связанные с
            законодательством, логистикой и документацией. Мы — команда профессионалов,
            готовых стать таким партнером для вашего бизнеса.
          </p>
          <ul className={styles.descList}>
            <li className={styles.descItem}>
              <span className={styles.descHighlight}>Таможенное оформление и сертификация:</span> полный пакет документов для прохождения таможенных процедур
            </li>
            <li className={styles.descItem}>
              <span className={styles.descHighlight}>Организация доставки:</span> безопасная транспортировка от поставщика до вашего склада
            </li>
            <li className={styles.descItem}>
              <span className={styles.descHighlight}>Юридическое сопровождение:</span> полная юридическая чистота сделки с учётом ваших интересов
            </li>
            <li className={styles.descItem}>
              <span className={styles.descHighlight}>Финансовое сопровождение:</span> контроль валютных операций и расчётов с контрагентами
            </li>
          </ul>
          <p className={styles.descText} style={{ marginTop: '1.5rem', fontWeight: 500 }}>
            Мы осуществляем комплексный подход: от первой консультации до получения груза.
          </p>
        </div>
      </div>
    </section>
  );
}
